module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 2-40e27136e55267f06e806090a0bba9de.png";